import { type FC, useEffect } from 'react';

import type { AnjouanLicenseConfig } from 'config/types';
import loadScript from 'utils/loadScript';

import type { GetLicenseProps } from './types';

const ICON_SIZE = 48;

const AnjouanLicense: FC<GetLicenseProps<AnjouanLicenseConfig>> = ({
  id,
  domId,
}) => {
  const readyToLoad = Boolean(id && domId);

  useEffect(() => {
    if (!readyToLoad) {
      return;
    }

    loadScript(`https://${id}.snippet.anjouangaming.org/anj-seal.js`);
  }, [readyToLoad, id]);

  if (!readyToLoad) {
    return null;
  }

  return (
    <div
      data-anj-image-size={ICON_SIZE}
      data-anj-image-type="basic-small"
      data-anj-seal-id={id}
      id={domId}
      style={{
        minWidth: ICON_SIZE,
        maxWidth: ICON_SIZE,
      }}
    />
  );
};

export default AnjouanLicense;
